module.exports = __webpack_public_path__ + "static/media/pin-white.0f043b8f.svg";